// className, content
export const stepsTours = t => [
  { selector: ".new-place-1", content: t("date") },
  { selector: ".new-place-2", content: "New place 2" },
];
